export function highlightMatch(
  text: string,
  keyword: string
): JSX.Element | string {
  if (typeof text !== "string") text = String(text ?? ""); // 👈 added type-safe conversion

  if (!text) return "";
  if (!keyword) return text;

  const escapeRegExp = (value: string) =>
    value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  const safeKeyword = escapeRegExp(keyword);
  const regex = new RegExp(`(${safeKeyword})`, "gi");

  const parts = text.split(regex);

  return (
    <>
      {parts.map((part, index) =>
        regex.test(part) ? <mark key={index}>{part}</mark> : part
      )}
    </>
  );
}
